import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ObservableSyncService } from '../sync/observable-sync.service';
import { ObservableNoteService } from './note-observable.service';
import { Note } from './note.dto';
import { ChangeTyped, mapSnapshotToDtos, NOTES_STORE, QueryService } from '@damofire/data-commons';

@Injectable()
export class IdbObservableNoteService extends ObservableNoteService {
  constructor(protected readonly observableSyncService: ObservableSyncService<Note>) {
    super();
  }

  observeIssueNotes(divisionId: string, issueId: string): Observable<Note[]> {
    return this.collectionData(divisionId, (notes) => this.filterByIssue(notes, issueId));
  }

  observeNotes(divisionId: string, inspectionId: string, assetId?: string): Observable<Note[]> {
    return this.collectionData(divisionId, (notes) => this.filter(notes, inspectionId, assetId));
  }

  observeDivisionNotes(divisionId: string): Observable<Note[]> {
    return this.collectionData(divisionId);
  }

  collectionData(divisionId: string, filter?: (docs: ChangeTyped<Note>[]) => ChangeTyped<Note>[]): Observable<Note[]> {
    const previousResults: Note[] = [];
    return this.observableSyncService.toObservable(NOTES_STORE, divisionId, filter).pipe(
      map((changes) => {
        mapSnapshotToDtos(previousResults, changes);
        return QueryService.applySort(previousResults, { sort: { 'audit.lastModifiedDate': 'desc' } });
      }),
    );
  }

  private filter(notes: ChangeTyped<Note>[], inspectionId: string, assetId?: string): ChangeTyped<Note>[] {
    if (assetId) {
      notes = notes.filter((i) => i.asset?._id === assetId);
    }
    return notes.filter((i) => i.inspection?._id === inspectionId);
  }

  private filterByIssue(notes: ChangeTyped<Note>[], issueId: string): ChangeTyped<Note>[] {
    return notes.filter((i) => i.issue?._id === issueId);
  }
}
